var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
// @ts-ignore:next-line
import { TitleManager } from '@folio/stripes/core';
import { LoadingPane } from '@folio/stripes/components';
import { useIntl } from 'react-intl';
import { computeErrorMessage, t } from '../../services';
import { useCreateListFormState } from './hooks';
import { useMessages, useRecordTypes, useCreateList, useKeyCommandsMessages } from '../../hooks';
import { CreateListLayout, MainCreateListForm } from './components';
import { HasCommandWrapper } from '../../components';
import { computeRecordTypeOptions } from './helpers';
import { handleKeyCommand } from '../../utils';
import { AddCommand } from '../../keyboard-shortcuts';
import { HOME_PAGE_URL } from '../../constants';
import { FIELD_NAMES } from '../../interfaces';
export var CreateListPage = function () {
    var history = useHistory();
    var intl = useIntl();
    var _a = useCreateListFormState(), state = _a.state, onValueChange = _a.onValueChange, hasChanges = _a.hasChanges, crossTenantType = _a.crossTenantType;
    var _b = useRecordTypes(), isLoadingRecords = _b.isLoading, _c = _b.recordTypes, recordTypes = _c === void 0 ? [] : _c;
    var _d = useMessages(), showSuccessMessage = _d.showSuccessMessage, showErrorMessage = _d.showErrorMessage;
    var showCommandError = useKeyCommandsMessages().showCommandError;
    var _e = useCreateList({
        listObject: state,
        onError: function (error) {
            (function () { return __awaiter(void 0, void 0, void 0, function () {
                var errorMessage;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, computeErrorMessage(error, 'callout.list.save.error', {
                                listName: state[FIELD_NAMES.LIST_NAME]
                            })];
                        case 1:
                            errorMessage = _a.sent();
                            showErrorMessage({ message: errorMessage });
                            return [2 /*return*/];
                    }
                });
            }); })();
        },
        onSuccess: function (list) {
            if (list.id) {
                showSuccessMessage({ message: t('callout.list.save.success', {
                        listName: state[FIELD_NAMES.LIST_NAME]
                    }) });
                history.push("list/".concat(list === null || list === void 0 ? void 0 : list.id));
            }
        }
    }), saveList = _e.saveList, isLoading = _e.isLoading;
    var closeViewHandler = useCallback(function () { return history.push(HOME_PAGE_URL); }, [history]);
    var description = state.description, listName = state.listName, visibility = state.visibility, status = state.status, recordType = state.recordType;
    var isRequiredMissing = !(listName === null || listName === void 0 ? void 0 : listName.length) || !(recordType === null || recordType === void 0 ? void 0 : recordType.length);
    var recordTypesOptions = computeRecordTypeOptions(recordTypes, recordType);
    if (isLoading || isLoadingRecords) {
        return React.createElement(LoadingPane, null);
    }
    var isSaveDisabled = isRequiredMissing || isLoading;
    var shortcuts = [
        AddCommand.save(handleKeyCommand(function () { return saveList(); }, !isSaveDisabled, function () { return showCommandError(); }))
    ];
    return (React.createElement(HasCommandWrapper, { commands: shortcuts },
        React.createElement(TitleManager, { record: intl.formatMessage({ id: 'ui-lists.title.createList' }) },
            React.createElement(CreateListLayout, { isSavingInProgress: isLoading, isSaveButtonDisabled: isSaveDisabled, onSave: saveList, onClose: closeViewHandler, onCancel: closeViewHandler, showModalOnCancel: hasChanges },
                React.createElement(MainCreateListForm, { selectedType: recordType, descriptionField: description, listNameField: listName, visibilityField: visibility, statusField: status, onValueChange: onValueChange, recordTypesOptions: recordTypesOptions, isQueryButtonDisabled: isRequiredMissing || isLoading, isCrossTenant: crossTenantType })))));
};
